import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './scss/main.scss'
import './Resources/css/index.css';
import './Resources/css/fonts.css'
import '.'
import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import store from './store'

import "react-responsive-carousel/lib/styles/carousel.min.css";


import 'react-morphing-modal/dist/ReactMorphingModal.css';
import "swagger-ui-react/swagger-ui.css"

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
